import React from "react"
import { footerCopyright } from "./Footer.module.scss"

const currentYear = new Date().getFullYear()

function FooterCopyright() {
  return (
    <div className={footerCopyright}>&copy; {`${currentYear} Eventbrite`}</div>
  )
}

export default FooterCopyright
